// apps/api/src/qxcircle/qxcircle-notification-read.ts
// Description: QXCircle mark-read helpers — Slice 22 mark all.
// Owner: Masa Bayu
// Date: 2026-08-24

import { NotFoundException } from "./_nestjs-common";
import type { QxCircleNotification } from "./qxcircle.types";

export function markQxCircleNotificationReadById(
  items: QxCircleNotification[],
  notificationId: string,
): QxCircleNotification {
  const item = items.find((n) => n.id === notificationId);
  if (!item) {
    throw new NotFoundException(`Notification not found: ${notificationId}`);
  }
  item.read = true;
  return item;
}

export function markAllQxCircleNotificationsRead(
  items: QxCircleNotification[],
): number {
  let marked = 0;
  for (const item of items) {
    if (!item.read) {
      item.read = true;
      marked += 1;
    }
  }
  return marked;
}
